import { ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { useNavigate } from 'react-router';
import { getOidcConfig } from '../../config/oidcConfig';
import { deserializeSignInState } from '../../utils/authUtils';

interface IConfiguredAuthProviderProps extends PropsWithChildren {
    silentRedirectPath: string;
}

export const ConfiguredAuthProvider: FunctionComponent<IConfiguredAuthProviderProps> = ({ children, silentRedirectPath }) => {
    const [oidcConfig, setOidcConfig] = useState<Awaited<ReturnType<typeof getOidcConfig>>>();

    const navigate = useNavigate();
    useEffect(() => {
        (async function () {
            setOidcConfig(await getOidcConfig(silentRedirectPath));
        })();
    }, [silentRedirectPath]);

    if (!oidcConfig) return <ZfLoadingSpinner style={{ margin: 'auto' }} />;

    return (
        <AuthProvider
            {...oidcConfig}
            onSigninCallback={(user) => {
                if (!user) throw new Error('No user');

                window.history.replaceState({}, document.title, window.location.pathname);

                const { returnTo } = deserializeSignInState(user);
                navigate(returnTo, { replace: true });
            }}
        >
            {children}
        </AuthProvider>
    );
};
